import axios from "axios"
import router from "@/routes/index.js"
const BASE_URL = "http://kf.ybkyl.com/"//线上
// 121.46.26.109
// const BASE_URL ="http://192.168.101.27:8092/"//线下
// http request 拦截器
axios.interceptors.request.use(
	config => {
			config.headers = {
				// 'content-type': "application/x-www-form-urlencoded",
				token: window.localStorage.getItem('token')
			}
		return config;
	},
	err => {
		return Promise.reject(err);
	});

// http response 拦截器
axios.interceptors.response.use(
	response => {
		// window.console.log(response)
		if (response.status === 200) {
			// window.console.log(response)
			if (response.data.success === 2) {
				router.push('/login')
				window.localStorage.removeItem('token');
				return Promise.reject(response) 
			}
			return Promise.resolve(response)
		} else {
			// window.console.log(response)
			return Promise.reject(response)
		}
		// return Promise.reject(response)
	},
	error => {
		//请求路径报错
		// window.console.log(error)
		// if (!error.response) {
		// 	Message.error('网络连接错误')
		// 	return Promise.resolve(error)
		// }
		return Promise.resolve(error)
	});

// 封装post请求
export let post = (url, data) => {
	return new Promise((resolve, reject) => {
		axios.post(BASE_URL + url, data)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
//封装get请求
export let get = (url, data) => {
	return new Promise((resolve, reject) => {
		axios.get(BASE_URL + url, {
				params: data
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
